import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "85c62X0KmJBW7tVfP7rEwsr", "App", undefined);

import AdCtr from "../ad/AdCtr";
import AdEvent from "../ad/AdEvent";
import Cfg from "./Cfg";
import DataManager from "./DataManager";
import EventManager from "./EventManager";
import GameCtr from "./GameCtr";
import LocalDBManager from "./LocalDBManager";
import NameDB from "./NameDB";
import PoolManager from "./PoolManager";
import ResManager from "./ResManager";
import SoundManager from "./SoundManager";
import MathBase from "./MathBase";
import DragonHandler from "./DragonHandler";
import CommonAmn from "./CommonAmn";
import { MapCtrl } from "../../MapCtrl";
export var App = /*#__PURE__*/function () {
  function App() {}

  _createClass(App, null, [{
    key: "DataMgr",
    get:
    /*** 游戏中的数据管理*/
    function get() {
      return DataManager.I;
    }
    /*** 本地存储的数据管理*/

  }, {
    key: "LocalDBMgr",
    get: function get() {
      return LocalDBManager.I;
    }
    /*** 音频管理*/

  }, {
    key: "SoundMgr",
    get: function get() {
      return SoundManager.I;
    }
    /*** 资源管理*/

  }, {
    key: "ResMgr",
    get: function get() {
      return ResManager.I;
    }
    /*** 对象池管理*/

  }, {
    key: "PoolMgr",
    get: function get() {
      return PoolManager.I;
    }
    /*** 消息事件管理*/

  }, {
    key: "EventMgr",
    get: function get() {
      return EventManager.I;
    }
    /*** 名字库管理*/

  }, {
    key: "NameDBMgr",
    get: function get() {
      return NameDB.I;
    }
    /*** 配置表数据管理*/

  }, {
    key: "CfgMgr",
    get: function get() {
      return Cfg.I;
    }
    /*** number处理器*/

  }, {
    key: "NumHandler",
    get: function get() {
      return MathBase.I.numHandler;
    }
    /*** 坐标处理器*/

  }, {
    key: "PosHandler",
    get: function get() {
      return MathBase.I.PosHandler;
    }
    /*** 龙骨处理器*/

  }, {
    key: "DragonHandler",
    get: function get() {
      return DragonHandler.I;
    }
    /*** 数组处理器*/

  }, {
    key: "ArrayHandler",
    get: function get() {
      return MathBase.I.arrayHandler;
    }
    /**通用Action管理 */

  }, {
    key: "CommonAmn",
    get: function get() {
      return CommonAmn.I;
    }
    /*** 游戏控制器*/

  }, {
    key: "GameCtrl",
    get: function get() {
      return GameCtr.I;
    }
    /*** 广告控制器*/

  }, {
    key: "AdCtrl",
    get: function get() {
      return AdCtr.I;
    }
    /*** 广告事件管理*/

  }, {
    key: "AdEventMgr",
    get: function get() {
      return AdEvent.I;
    }
    /**地图管理 */

  }, {
    key: "MapCtr",
    get: function get() {
      return MapCtrl.I;
    }
  }]);

  return App;
}();

_cclegacy._RF.pop();